import { render, staticRenderFns } from "./gogIndex.vue?vue&type=template&id=394cd490&scoped=true&"
import script from "./gogIndex.vue?vue&type=script&lang=js&"
export * from "./gogIndex.vue?vue&type=script&lang=js&"
import style0 from "./gogIndex.vue?vue&type=style&index=0&id=394cd490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394cd490",
  null
  
)

export default component.exports